import React, {FC} from 'react'

export const ReactionIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='12' cy='12' r='10'/>
        <circle cx='8' cy='10' r='1' fill='currentColor'/>
        <circle cx='16' cy='10' r='1' fill='currentColor'/>
        <path d='M8 15c0 0 1.5 2 4 2s4-2 4-2'/>
    </svg>
)
